const initialState = {
	isMobileOrTabletDetected: false,
	isLabelSelectedOnMobile: false
};

const mobileReducer = ( state = initialState, action ) => {
	switch (action.type) {
		case "IS_MOBILE_OR_TABLET_DETECTED":
			state = {
				...state,
				isMobileOrTabletDetected: action.payload
			};
			break;
		case "IS_LABEL_SELECTED_ON_MOBILE":
			state = {
				...state,
				isLabelSelectedOnMobile: action.payload
			};
			break;
		default:
			return state;
	}
	return state;
};

export default mobileReducer;
